module.exports = __webpack_public_path__ + "img/buni-token.7cc80d48.svg";